import { render, staticRenderFns } from "./subHead.vue?vue&type=template&id=7ed01ec3&scoped=true&"
import script from "./subHead.vue?vue&type=script&lang=js&"
export * from "./subHead.vue?vue&type=script&lang=js&"
import style0 from "./subHead.vue?vue&type=style&index=0&id=7ed01ec3&prod&lang=css&"
import style1 from "./subHead.vue?vue&type=style&index=1&id=7ed01ec3&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ed01ec3",
  null
  
)

export default component.exports